import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "../utils/page-title";

export const Route = createFileRoute("/friends")({
  // Friends data and auth are currently backed by browser storage. Keep this
  // client-only until the session moves to a request-readable cookie.
  ssr: false,
  head: () =>
    pageHead("Your Friends", {
      canonicalPath: "/friends",
      robots: "noindex, nofollow",
    }),
});
